import { useIntl } from 'react-intl';
import { useQuery } from 'react-query';

import { CommonWorkflowService } from '@savgroup-front-common/core/api';

export const GetFileStatesQuery = 'getFileStatesQuery';

export const useGetFileStatesQuery = ({ fileId }: { fileId?: string }) => {
  const { locale } = useIntl();

  const { data: histories, isLoading } = useQuery(
    [GetFileStatesQuery, { fileId, locale }],
    async () => {
      if (!fileId) {
        return undefined;
      }

      const response = await CommonWorkflowService.getFileStatesQuery({
        fileId,
        language: locale,
      });

      if (response.failure) {
        throw new Error(response.errors[0]?.message);
      }

      return response.value;
    },
    {
      staleTime: 500,
      keepPreviousData: true,
    },
  );

  return {
    histories,
    isLoading,
  };
};
